import { useLibraryEntry } from "../lib/queries";

interface LibraryEntryCues {
  id: string;
  name: string;
  description: string | null;
}

/**
 * The coaching cues an exercise carries in the library, read live rather than copied.
 *
 * Picking a library exercise used to paste its description into the plan, which meant the plan owned a
 * dead copy: fixing a cue in the library ("brace before the first rep, not during") left every plan
 * already written still telling athletes the old thing, with no way to find them short of opening each
 * one. Referenced, an edit in the library reaches every plan that points at it -- which is the whole
 * reason the exercise lives in a library and not in the plan.
 *
 * Per-plan cues are a separate field and sit alongside these, so "for this athlete, land softer" stays
 * with the athlete it was written for and never overwrites the shared text.
 *
 * Renders nothing while loading, on error, or when the entry has no description -- absent cues are a
 * normal state, and a spinner or an error line for a paragraph of optional text is noise on a screen
 * where an athlete is mid-workout.
 */
export function LibraryCues({ entryId, className = "element-notes" }: { entryId?: string; className?: string }) {
  const query = useLibraryEntry<LibraryEntryCues>(entryId);
  const description = query.data?.description?.trim();
  if (!entryId || !description) return null;
  return <p className={className}>{description}</p>;
}
